import { render, staticRenderFns } from "./CheckboxGroupField.vue?vue&type=template&id=4d022b10&"
import script from "./CheckboxGroupField.vue?vue&type=script&lang=ts&"
export * from "./CheckboxGroupField.vue?vue&type=script&lang=ts&"
import style0 from "./CheckboxGroupField.vue?vue&type=style&index=0&id=4d022b10&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports